export default {
  // フッター
  TERMS_OF_SERVICE: "Terms of service",
  PRIVACY_POLICY: "Privacy policy",
  COMPANY_INFORMATION: "Company information",
  MAILORDERLAW_DETAILS: "Display of Information Based on the Specified Commercial Transactions Act",
  ATAMI_CITY_TOURISM_ASSOCIATION: "Atami City Tourism Association",
};
